export default __webpack_public_path__ + "static/media/126.6fca44fb.svg";